import { events } from '@Events';
import type { Middleware } from '@reduxjs/toolkit';
import { resetStore } from '../resetAction';

/**
 * Middleware that listens to the global 'logout' event and resets all store state.
 * This avoids a circular dependency between AuthProvider and the store.
 */
export const logoutMiddleware: Middleware = (storeAPI) => {
    if (typeof window !== 'undefined') {
        events.on('logout', () => {
            localStorage.clear();
            storeAPI.dispatch(resetStore());
        });
    }

    return (next) => (action) => next(action);
};
